"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconStar = function IconStar(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 27 26",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.3152 20.72L5.08667 25.326L6.92417 16.0767L0 9.674L9.36483 8.56333L13.3152 0L17.2655 8.56333L26.6303 9.674L19.7062 16.0767L21.5437 25.326L13.3152 20.72Z",
    fill: color
  }));
};

IconStar.defaultProps = {
  color: 'black',
  size: 30
};
IconStar.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconStar;
exports.default = _default;